const actions = {
    GET_TICKETS_REQUEST: 'GET_TICKETS_REQUEST',
    GET_TICKETS_SUCCESS: 'GET_TICKETS_SUCCESS',

    GET_TICKET_DETAIL_REQUEST: 'GET_TICKET_DETAIL_REQUEST',
    GET_TICKET_DETAIL_SUCCESS: 'GET_TICKET_DETAIL_SUCCESS',

    CREATE_TICKET_REQUEST: 'CREATE_TICKET_REQUEST',

    CAMBIAR_ESTADO_TICKET_REQUEST: 'CAMBIAR_ESTADO_TICKET_REQUEST',
    COMENTAR_TICKET_REQUEST: 'COMENTAR_TICKET_REQUEST',

    getTickets: (query) => ({ type: actions.GET_TICKETS_REQUEST, query }),
    getTicketDetail: (id) => ({ type: actions.GET_TICKET_DETAIL_REQUEST, id }),
    createTicket: (data, history) => ({
        type: actions.CREATE_TICKET_REQUEST,
        data,
        history
    }),
    cambiarEstadoTicket: (id, data) => ({
        type: actions.CAMBIAR_ESTADO_TICKET_REQUEST,
        id,
        data
    }),
    comentarTicket: (id, data) => ({
        type: actions.COMENTAR_TICKET_REQUEST,
        id,
        data
    }),
};
export default actions;
